import React, { Component } from "react";

import Spinner from "../Spinner/Spinner";
import Alert from "../Alert/Alert";
import "./styles.css";
import {
  PASSWORD_BUTTON_TEXT,
  PASSWORD_CHANGE_ERROR,
  PASSWORD_CHANGE_ERROR_DESCRIPTION,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_SUCCESS_DESCRIPTION,
  PASSWORD_CONFIRM_LABEL,
  PASSWORD_DIFF,
  PASSWORD_ERROR_TEXT,
  PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MUST_CONTAIN,
  PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_NUMBER,
  PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_CAPITAL_LETTER,
  PASSWORD_ERROR_TEXT_RULE_MINIMUM_PASSWORD_LENGTH,
  PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_LOWERCASE_LETTER,
  PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_SPECIAL_CHARACTERS,
  PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MAY_NOT_CONTAIN,
  PASSWORD_ERROR_TEXT_RULE_SEQUENCES_OF_X_OR_MORE_REPEATED_CHARACTERS,
  PASSWORD_LABEL,
} from "../../i18n/constants";
import { getQueryStringValue } from "../../helpers/getQueryStringValue";
import getUrl from "../../helpers/getUrl";
import { UserRegion } from "../../helpers/enums";

const FormInput = (props) => {
  const handleClick = () => {
    props.setInfo();
  };
  return (
    <label className="form-iten">
      <span>{props.label}</span>
      <input onClick={handleClick} type={props.type} onChange={props.change} />
      <span
        className={props.type === "text" ? "form-iten-text" : "form-iten-pass"}
        onClick={props.typeChange}
      ></span>
    </label>
  );
};

const FormError = (props) => {
  const { t } = props;
  const errors = {
    format: t(PASSWORD_ERROR_TEXT),
    diferent: t(PASSWORD_DIFF),
    none: "",
    server: props.text,
    passwordFormatRules: [
      {
        id: "ruleset1",
        message: t(PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MUST_CONTAIN),
        rules: [
          {
            id: "rule1",
            message: t(PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_NUMBER),
          },
          {
            id: "rule2",
            message: t(PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_CAPITAL_LETTER),
          },
          {
            id: "rule3",
            message: t(PASSWORD_ERROR_TEXT_RULE_MINIMUM_PASSWORD_LENGTH),
          },
          {
            id: "rule4",
            message: t(PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_LOWERCASE_LETTER),
          },
          {
            id: "rule5",
            message: t(PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_SPECIAL_CHARACTERS),
          },
        ],
      },
      {
        id: "ruleset2",
        message: t(PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MAY_NOT_CONTAIN),
        rules: [
          {
            id: "rule1",
            message: t(PASSWORD_ERROR_TEXT_RULE_SEQUENCES_OF_X_OR_MORE_REPEATED_CHARACTERS),
          },
        ],
      },
    ],
  };
  return (
    errors[props.message].length > 0 &&
    ((props.message === "format" || props.message === "server") ? (
      <PasswordRuleSet rulesets={errors.passwordFormatRules} />
    ) : (
      <ul className="form-error">
        <li>{errors[props.message]}</li>
      </ul>
    ))
  );
};

const PasswordRuleSet = ({ rulesets }) => {
  return (
    rulesets.length > 0 && (
      <div className="form-error">
        {rulesets.map((ruleset) => (
          <div className="ruleset" key={ruleset.id}>
            <p className="rule-title">{ruleset.message}</p>
            {ruleset.rules.length > 0 && (
              <ul className="rules">
                {ruleset.rules.map((rule) => (
                  <li className="rule" key={rule.id}>
                    {rule.message}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    )
  );
};

export default class FormPasswordReset extends Component {
  state = {
    passChangeModal: false,
    passChangeSuccess: false,
    requestPassChange: false,
    pass1: {
      value: "",
      label: this.props.t(PASSWORD_LABEL),
      type: "password",
    },
    pass2: {
      value: "",
      label: this.props.t(PASSWORD_CONFIRM_LABEL),
      type: "password",
    },
    error: {
      message: "none",
      value: "",
    },
    button: {
      label: this.props.t(PASSWORD_BUTTON_TEXT),
    },
  };

  componentDidUpdate(prevProps) {
    if (prevProps.passwordLabel !== this.props.passwordLabel) {
      const newState = this.state;
      newState.pass1.label = this.props.t(PASSWORD_LABEL);
      newState.pass2.label = this.props.t(PASSWORD_CONFIRM_LABEL);
      newState.button.label = this.props.t(PASSWORD_BUTTON_TEXT);
      this.setState(newState);
    }
  }

  closeModal = () => {
    this.setState({
      ...this.state,
      passChangeModal: false,
    });
  };

  setInfo = () => {
    const newState = this.state;
    newState.error.message = "format";
    this.setState(newState);
  };

  validate = (event) => {
    event.preventDefault();
    const newState = this.state;
    const requireds = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    let isPassValid = requireds.test(this.state.pass1.value);

    if (!isPassValid) {
      newState.error.message = "format";
      this.setState(newState);
      return;
    }
    isPassValid = newState.pass1.value === newState.pass2.value;
    if (!isPassValid) {
      newState.error.message = "diferent";
      this.setState(newState);
      return;
    }
    // TODO execute request  senha test >> !=M@u777
    const changeKey = getQueryStringValue("pwrt");

    newState.requestPassChange = true;
    this.setState(newState);

    const regionName = this.props.region ? this.props.region : UserRegion.BRASIL;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "10bd6366-740f-4134-8372-40658ea1d91d",
        // "method.response.header.Access-Control-Allow-Origin": "'*'",
        region: regionName,
      },
      // please add api/secret keys on .env in order to make requests
      body: JSON.stringify({
        pwrt: changeKey,
        // passwordResetToken: "3_aQphOgnR2NS0FsZekBk4d9YEwLYkceP6nWPUW4KIGgRQpAln6ZEjl9-mPKEnYLkL&pwrt=tk1..AcbHLNf7vQ.cZfbWQ3uuWBLz1QvXnEP7ONlGFMGIaxp-YeJ_wAihIKqez4CgYY5sIZCk7CbZggk.LLdODWm8pPxCZ2F-fhkrx9PaYOoUWvy5NxLy72gzS4-kky6whyncwX3QodWAxUxzQGITENpmIzFZDCqrbes1xA.sc3&lang=en",
        password: newState.pass1.value,
      }),
    };

    const defineURL = getUrl();
    const buildURL = "https://" + defineURL + "/users/forgot";

    fetch(buildURL, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        if (!response.status) {
          newState.passChangeSuccess = false;
          newState.passChangeModal = true;
          newState.requestPassChange = false;
          this.setState(newState);
          return;
        }
        newState.passChangeSuccess = true;
        newState.passChangeModal = true;
        newState.requestPassChange = false;
        this.setState(newState);
      })
      .catch((error) => {
        newState.requestPassChange = false;
        newState.passChangeSuccess = false;
        newState.passChangeModal = true;
        newState.error.message = "server";
        newState.error.text = this.props.t(PASSWORD_ERROR_TEXT);
        this.setState(newState);
      });
  };

  render() {
    return (
      <div className="reset-container">
        <form className="reset-form" onSubmit={this.validate}>
          <fieldset>
            <FormInput
              {...this.state.pass1}
              setInfo={this.setInfo}
              {...{
                change: (event) => {
                  const newState = this.state;
                  newState.pass1.value = event.target.value;
                  this.setState(newState);
                },
                typeChange: () => {
                  const newState = this.state;
                  newState.pass1.type =
                    newState.pass1.type === "text" ? "password" : "text";
                  this.setState(newState);
                },
              }}
            />
            <FormInput
              {...this.state.pass2}
              setInfo={this.setInfo}
              {...{
                change: (event) => {
                  const newState = this.state;
                  newState.pass2.value = event.target.value;
                  this.setState(newState);
                },
                typeChange: () => {
                  const newState = this.state;
                  newState.pass2.type =
                    newState.pass2.type === "text" ? "password" : "text";
                  this.setState(newState);
                },
              }}
            />
            <FormError t={this.props.t} {...this.state.error} />
            <button type="submit">{this.state.button.label}</button>
          </fieldset>
        </form>
        {this.state.requestPassChange && !this.state.passChangeModal && (
          <div className="loading">
            <Spinner></Spinner>
          </div>
        )}
        {this.state.passChangeModal && (
          <Alert
            closeModal={this.closeModal}
            isOpen={this.state.passChangeModal}
            error={!this.state.passChangeSuccess}
            title={
              this.state.passChangeSuccess
                ? this.props.t(PASSWORD_CHANGE_SUCCESS)
                : this.props.t(PASSWORD_CHANGE_ERROR)
            }
            text={
              this.state.passChangeSuccess
                ? this.props.t(PASSWORD_CHANGE_SUCCESS_DESCRIPTION)
                : this.props.t(PASSWORD_CHANGE_ERROR_DESCRIPTION)
            }
            submitButtonText="Ok.ENTENDI"
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormPasswordReset/FormPasswordReset.js